export enum DevelopersRoutes {
  Statics = 'statistics',
  Documentation = 'documentation',
  DynamicData = 'dynamicData',
  UseApi = 'useApi'
}
